<template>
  <form id="detailInfoModal">
    <b-modal
      v-model="show"
      size="lg"
      hide-header
      hide-footer
      centered
      @hide="hideModal"
    >
      <div class="modal-header align-items-center">
        <h2
          id="ModalLabel"
          class="modal-title"
        >
          Детальная информация
        </h2>
        <i class="material-icons">info_outline</i>
      </div>
      <div class="modal-body break-word">
        <vue-json-pretty
          v-if="detailInfo && detailInfo.data"
          :deep="2"
          show-length
          :select-on-click-node="false"
          :data="detailInfo.data"
        />
        <div
          v-else
          class="d-flex py-4"
        >
          <span class="mx-auto">Нет данных</span>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-primary-ford-orange modal-ext"
          type="button"
          @click="hideModal"
        >
          Закрыть
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
export default {
  name: 'DetailInfoModal',
  props: {
    value: Boolean,
    detailInfo: Object,
  },
  data: () => ({
    show: false,
  }),
  watch: {
    value(val) {
      this.show = val;
    },
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.break-word {
  overflow-wrap: break-word;
}
</style>
